module.exports = __webpack_public_path__ + "ptc_nakagawa_N1.d244a7ff.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/nakagawa/parent_to_child/ptc_nakagawa_N1.jpg
// module id = vIj1
// module chunks = 0